export const SIDEBAR_TEMPLATE = 'edit-site/template';
export const SIDEBAR_BLOCK = 'edit-site/block-inspector';
